<template>
  <Alert type="warning">
    <template #title>{{ t("title") }}&nbsp;</template>
    <template v-if="showSettlementExplanation">
      <strong>{{ t("settlement_legal_intro") }}&nbsp;</strong>
      {{ t("settlement_legal_text") }}
      <br />
      {{ t("settlement_legal_monthly") }}
    </template>
    <span v-else>{{ alertMessage }}</span>
  </Alert>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapGetters } from "vuex";
import { Alert } from "@estaly/ui";

export default {
  components: { Alert },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    ...mapGetters("claims", [
      "finalSettlementPaymentRequired",
      "finalSettlementAndDeductiblePaymentRequired",
      "declarationUpdateRequired",
      "anyPaymentRequired",
      "customerIbanRequired",
      "externalMerchantQuotationRequired",
      "externalMerchantInvoiceRequired",
    ]),
    showSettlementExplanation() {
      return this.finalSettlementAndDeductiblePaymentRequired || this.finalSettlementPaymentRequired;
    },
    alertMessage() {
      if (this.declarationUpdateRequired) return this.t("alert_declaration_update");
      if (this.anyPaymentRequired) return this.t("alert_payment");
      if (this.customerIbanRequired) return this.t("alert_iban");
      if (this.externalMerchantQuotationRequired) return this.t("alert_quotation");
      if (this.externalMerchantInvoiceRequired) return this.t("alert_invoice");
      return this.t("alert_default");
    },
  },
};
</script>

<i18n src="./RequiredActionAlert.i18n.json"></i18n>
